import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AppSettings } from '../../app.settings';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { MetaDataService } from '../../services/meta-data.service';
import { CheckboxMultiselectComponent } from '../mi-fields/checkbox-multiselect/checkbox-multiselect.component';
import { MiFieldsComponent } from '../mi-fields/mi-fields.component';
import { MiTooltipComponent } from '../mi-fields/mi-tooltip/mi-tooltip.component';
import { MiErrorComponent } from '../mi-error/mi-error.component';
import { SpecialLabelsComponent } from '../special-labels/special-labels.component';
import { GeneralSettingsFormComponent } from '../general-settings-form/general-settings-form.component';
@Component({
  selector: 'app-mi-form',
  templateUrl: './mi-form.component.html',
  styleUrls: ['./mi-form.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MiFieldsComponent, MiErrorComponent,
    ButtonModule, MiTooltipComponent,
    TranslateModule, CheckboxMultiselectComponent, CommonModule, SpecialLabelsComponent, GeneralSettingsFormComponent]
})
export class MiFormComponent implements OnInit {
  @Input() attributeLabels: [];
  @Input() isTwoColStructure: boolean = false;
  @Input() moduleName: string;
  @Input() groups: any;
  @Input() submitBtnText: string;
  @Input() previousBtnText: string;
  @Input() saveAndAddBtnText: string;
  @Input() attributeValues: [];
  @Input() activeIndex;
  @Input() showImg: boolean = false;
  @Input() docType: any;
  @Input() bookingTimeRestrictionIds: any = [];
  @Input() vehicleDocumentEntityIdList;
  @Input() driverDocumentEntityIdList;
  @Input() driverDrivingRecordIds: any = [];
  @Input() addressEntityIdList: any = [];
  @Input() edit: boolean = false;
  @Input() isMultipleFilesUpload: boolean = false;
  @Input() multiSelectDisplay: any = 'comma';
  @Input() dateFormat: any = this.metaDataService.lowerDateFormat;
  @Input() saveBtnId: string;
  @Input() previousBtnId: string;
  @Input() defaultLocationList: any = [];
  @Input() displaySubmitButtons: boolean = true;
  @Input() selectedLoginOptionIds;
  @Input() concernId;
  @Input() uploadDocumentValue: [];
  @Input() isShowBookingMap: boolean;
  @Input() hideCancelAndSubmitBtn: boolean = false;
  @Input() isResetPrivilege;
  @Input() passengerTypeToReset;
  @Input() showCancelButton: boolean = false;
  @Input() set submitButtonDisabled(value: boolean) {
    this.saveBtnDisabled = value;
  }
  pKeyFilterForEmergencyContactName: RegExp = AppSettings.NAME_PATTERN;
  pKeyFilterForBarcode = AppSettings.KEY_FILTER_FOR_BARCODE;
  @Output() saveData: EventEmitter<any> = new EventEmitter();
  @Output() onSaveAndAdd: EventEmitter<any> = new EventEmitter();
  @Output() onClickCancel: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() previousClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() formGroupEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoveVehicleDocumentEntity: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoveDriverDocumentEntity: EventEmitter<any> = new EventEmitter<any>();
  @Output() driverDocumentFieldsLength: EventEmitter<any> = new EventEmitter<any>();
  @Output() vehicleDocumentFieldsLength: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoveDriverDrivingRecordEntity: EventEmitter<any> = new EventEmitter<any>();
  miFormGroup: FormGroup;
  formGroupFields = [];
  public fields = [];
  GROUP_CODE = AppSettings.GROUP_CODE;
  entityCodes = AppSettings.ENTITY_CODE;
  entityTypes = AppSettings.ENTITY_TYPE;
  currentSelectedCode: string;
  excludeAttributeCodes = ['people_count', 'drivers', 'role_code', 'assigned_drivers', 'removed_drivers', 'added_drivers', 'driver_entity_id', 'next_shift_location_address', 'next_shift_location_type', 'reported_by_name'];
  differentLabelSet = ['barcode', 'generate_code_for_booking', 'special_login'];
  multiSelectCheckBoxSet = ['require_at_least_one', 'select_data_to_include']
  excludedGroupCodes = [AppSettings.GROUP_CODE.STAY_HOME_ADDRESS,
  AppSettings.GROUP_CODE.BOOKING_TIME_RESTRICTION,
  AppSettings.GROUP_CODE.DRIVER_DRIVING_RECORD,
  AppSettings.GROUP_CODE.DRIVER_DOCUMENT,
  AppSettings.GROUP_CODE.ADDRESS,];
  saveBtnDisabled: boolean = false;
  uploadDocumentValueIds;
  imgIdAndImgUrl: any;
  fileImgAttributeCode: any
  private readonly SYRINGE_CONST = { Syringe: 'Syringe' };

  constructor(public cs: CommonBindingDataService, private metaDataService: MetaDataService,
    private el: ElementRef,
    private fb: FormBuilder) {
  }

  ngOnInit() {
    this.groups = this.sortFormFields();
    this.buildForm();
    this.onChangeProductName();
  }


  onChangeProductName() {
    if (this.moduleName === AppSettings.ENTITY_CODE.PRODUCT) {
      const updateProductName = () => {
        const drugName = this.miFormGroup.controls.drug_name?.value || '';
        const strength = this.miFormGroup.controls.strength?.value || '';
        const presentation = this.miFormGroup.controls.presentation?.value || '';
        const packType = this.miFormGroup.controls.pack_type?.value || '';
        const packSize = this.miFormGroup.controls.pack_size?.value ? `[${this.miFormGroup.controls.pack_size?.value}]` : '';

        const productNameValue = `${drugName} ${strength} ${presentation} ${packType} ${packSize}`.trim();
        this.miFormGroup.controls.product_name.setValue(productNameValue);
      };

      const fields = ['drug_name', 'strength', 'presentation', 'pack_size', 'pack_type'];
      fields.forEach(field => {
        if (this.miFormGroup.controls[field]) {
          this.miFormGroup.controls[field].valueChanges.subscribe(updateProductName);
        }
      });

      updateProductName();
    }
  }


  onPreviousClick() {
    this.previousClick.emit();
  }

  onNextClick() {
    this.nextClick.emit();
  }

  getValues() {
  }

  get value() {
    return this.miFormGroup.value;
  }

  sortFormFields() {
    return this.groups.map(group => {
      group.fields.sort((a, b) => a.attributeIndex - b.attributeIndex);
      return group;
    });
  }

  formGroupEmitEvent(event) {
    this.formGroupEmit.emit(event);
  }

  private buildForm() {
    this.buildGroups();
  }

  private buildGroups() {
    const miFormControl = this.getFormControl();
    this.miFormGroup = new FormGroup(miFormControl);
    if (this.imgIdAndImgUrl?.imgId && this.imgIdAndImgUrl?.imgUrl) {
      this.miFormGroup.controls[this.fileImgAttributeCode].setValue(this.imgIdAndImgUrl);
    }
    this.formGroupEmit.emit(this.miFormGroup);
  }

  resetForm() {
    this.miFormGroup.reset();
  }

  onRemoveVehicleDocument(event) {
    this.onRemoveVehicleDocumentEntity.emit(event);
  }

  onRemoveDriverDocument(event) {
    this.onRemoveDriverDocumentEntity.emit(event);
  }

  driverDocumentFieldsChanges(event) {
    this.driverDocumentFieldsLength.emit(event)
  }

  vehicleDocumentFieldsChanges(event) {
    this.vehicleDocumentFieldsLength.emit(event)
  }

  onRemoveDriverDrivingRecord(event) {
    this.onRemoveDriverDrivingRecordEntity.emit(event);
  }

  private getFormControl() {
    for (const group of this.groups) {
      if (this.isShouldProcessGroup(group)) {
        for (const field of group.fields) {
          this.currentSelectedCode = field.inputCode;
          const validators = this.addValidator(field.validation);
          field.fieldName = field.attributeCode;
          let value: any = this.attributeValues ? this.attributeValues[field?.attributeCode] : '';

          if (field.inputCode === 'select' && this.attributeValues && this.attributeValues[field?.attributeCode]) {
            const attributeValue = this.attributeValues[field?.attributeCode];
            if (typeof attributeValue === 'object') {
              value = Object.keys(attributeValue)[0];
            }
          }

          if (field.inputCode === 'hourMinute' && value) {
            const timestamp = parseInt(value);
            if (!isNaN(timestamp)) {
              value = new Date(timestamp);
            }
          }
          if ((field.inputCode === 'checkBox' || field.inputCode === 'checkbox') && this.attributeValues && this.attributeValues[field?.attributeCode]) {
            const attributeValue = this.attributeValues[field?.attributeCode];
            if (typeof attributeValue === 'object') {
              const key = Object.keys(attributeValue)[0];
              value = key === 'Yes' ? key : '';
            }
          }
          field.attributeCode = field.attributeCode === 'length' ? `${field.attributeCode}_mi` : field.attributeCode;
          const control = new FormControl(value, validators);
          if (this.moduleName === AppSettings.ENTITY_CODE.PRODUCT && field.attributeCode === 'product_name') {
            control.disable();
          }
          this.formGroupFields[field.attributeCode] = control;
          if (field.inputCode.includes('date')) {
            this.setMinMaxDateForDateField(group, field);
          }
          if (field.inputCode.includes('inputInt')) {
            this.setMinMaxForInputIntField(group, field);
          }
          if (field.inputCode.includes('fileImg') || field.inputCode.includes('fileImgPdf')) {
            this.setImageUrlAndImageIdToFormControl(field);
          }
          if (this.moduleName === AppSettings.ENTITY_CODE.LOCATION) {
            this.formGroupFields[AppSettings.LOCATION_ATTRIBUTES.LOCATION_PLACE_ID] = new FormControl(value);
          }
        }
      }
    }
    return this.formGroupFields;
  }

  setImageUrlAndImageIdToFormControl(field) {
    const imgurl = Object.entries(this.attributeValues).find(([k]) => k.includes('image_url') || k.includes('images_url') || k.includes('logo_url') || k.includes('upload_document_url'));
    if (imgurl && this.attributeValues[field.attributeCode]) {
      this.imgIdAndImgUrl = {
        imgId: this.attributeValues[field.attributeCode],
        imgUrl: imgurl ? imgurl[1] : null
      }
    }
    this.fileImgAttributeCode = field.attributeCode;
  }

  private setMinMaxDateForDateField(group, field) {
    if (field.inputCode === AppSettings.DATE_OF_BIRTH_INPUT_CODE) {
      field.validation.max = new Date();
    }
    if ((group.code === AppSettings.TRANSPORTATION_RESTRICTION_GROUP && this.moduleName === AppSettings.ENTITY_CODE.EVENTS) || group.code === AppSettings.RELATED_SETTINGS
    ) {
      const date = new Date();
      date.setHours(0)
      date.setMinutes(0);
      date.setSeconds(1);
      field.validation.min = date;
    }
  }

  private setMinMaxForInputIntField(group, field) {
    if (field.attributeCode === AppSettings.SERVICE_AREA_RADIUS) {
      field.validation.max = 99;
      field.validation.min = 1;
    }
  }

  private addValidator(rules) {
    const stringValues = ['inputString', 'text', 'textArea', 'inputMobile', 'inputAutocomplete', 'inputUniqueId', 'entitySelectSearch'];
    if (!rules) {
      return [];
    }
    const validators = [];
    (Object.keys(rules).map((rule) => {
      const isString = stringValues.includes(this.currentSelectedCode);
      if (rule === "required" && rules.required == true) {
        validators.push(Validators.required);
      }

      if (rule === "min" && rules.min && !isString) {
        if (rules[rule] !== null) {
          validators.push(Validators.min(rules[rule] ? rules[rule] : 10))
        }
      }

      if (rule === "max" && rules.max && !isString) {
        if (rules[rule] !== null) {
          validators.push(Validators.max(rules[rule] ? rules[rule] : 50));
        }
      }

      if (rule === "min" && rules.min && isString) {
        if (rules[rule] !== null) {
          validators.push(Validators.minLength(rules[rule] ? rules[rule] : 10));
        }
      }

      if (rule === "max" && rules.max && isString) {
        if (rules[rule] !== null) {
          validators.push(Validators.maxLength(rules[rule] ? rules[rule] : 50));
        }
      }

      if (rule === "pattern" && rules.pattern) {
        if (rules[rule] !== null) {
          const validatorRule = new RegExp([rules[rule]].join(''));
          validators.push(Validators.pattern(rules[rule] ? validatorRule : ''));
        }

      }
      if (rule === "unique" && rules.unique == true) {
        validators.push(Validators.pattern(''));

      }
    }));

    return validators;
  }


  submitData() {
    if (this.saveBtnDisabled) {
      return;
    }

    if (this.miFormGroup.valid) {
      this.saveBtnDisabled = true;
      this.saveData.next(this.miFormGroup.getRawValue());
      setTimeout(() => {
        this.saveBtnDisabled = false;
      }, 3000);
      this.onNextClick();
    } else {
      this.miFormGroup.markAllAsTouched();
      if (this.moduleName === AppSettings.ENTITY_TYPE.GENERAL_SETTINGS) {
        this.setFocusOnErrorField();
      } else {
        const firstElementWithError = document.querySelector('.ng-invalid');
        this.scrollTo(firstElementWithError);
      }
    }
  }

  setFocusOnErrorField() {
    Object.keys(this.miFormGroup.controls).forEach(key => {
      if (this.miFormGroup.controls[key].hasError('required')) {
        const num = key.split('_');
        const ele = document.getElementById(`${num[0]}_select_button`);
        if (ele) {
          ele.click();
          this.scrollTo(ele);
        } else {
          const firstElementWithError = document.querySelector('.ng-invalid');
          this.scrollTo(firstElementWithError);
        }
      }
    });
  }

  saveAndAddData() {
    if (this.saveBtnDisabled) {
      return;
    }

    if (this.miFormGroup.valid) {
      this.saveBtnDisabled = true;
      this.onSaveAndAdd.next(this.miFormGroup.getRawValue());
      this.miFormGroup.reset();
      setTimeout(() => {
        this.saveBtnDisabled = false;
      }, 500);
    } else {
      this.miFormGroup.markAllAsTouched();
      const firstElementWithError = document.querySelector('.ng-invalid');
      this.scrollTo(firstElementWithError);
    }
  }

  onClickCancelFun() {
    this.onClickCancel.emit();
  }

  handleCancel() {
    this.resetForm();
    this.onCancel.emit();
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }


  isPassengerStayHomeAddress(group: any): boolean {
    return group.code === this.GROUP_CODE.STAY_HOME_ADDRESS &&
      this.moduleName === this.entityCodes.PASSENGER;
  }

  isGeneralSettingsAddress(group: any): boolean {
    return group.code === 'address' &&
      this.moduleName === this.entityTypes.GENERAL_SETTINGS;
  }

  isNotSpecialAddressField(field: any): boolean {
    const specialAddresses = ['location_address', 'event_address', 'driver_address'];
    return !specialAddresses.includes(field.attributeCode);
  }

  getFieldClass(attributeCode: string): string {
    switch (attributeCode) {
      case 'generate_code_for_booking':
        return 'relative generate-code-field';
      case 'special_login':
        return 'relative special-login-field';
      default:
        return '';
    }
  }

  isShouldProcessGroup(group: any): boolean {
    return (
      (group.code !== AppSettings.GROUP_CODE.STAY_HOME_ADDRESS || this.moduleName !== this.entityCodes.PASSENGER) &&
      !this.excludedGroupCodes.includes(group.code)
    );
  }

  isDefaultValues(group): boolean {
    return group.code === this.GROUP_CODE.DEFAULT_VALUES &&
      this.moduleName === 'order_gen_sett';
  }

  isNotificationSettings(group): boolean {
    return group.code === this.GROUP_CODE.NOTIFICATION_EMAIL
  }

  isDownloadAccountData(group): boolean {
    return group.code === this.GROUP_CODE.DOWNLOAD_ACCOUNT_DATA;
  }

  isPasswordRequirements(group): boolean {
    return group.code === this.GROUP_CODE.PASSWORD_REQUIREMENTS;
  }

  isSessionTimeout(group): boolean {
    return group.code === this.GROUP_CODE.SESSION_TIMEOUT;
  }

  isStandardGroup(group: any): boolean {
    const excludedGroups = ['send_notification', 'default', 'setting'];
    return !excludedGroups.includes(group.code);
  }

  shouldShowSpecialLabels(group): boolean {
    return this.isDefaultValues(group) ||
      this.isNotificationSettings(group) ||
      this.isStandardGroup(group) ||
      this.isDownloadAccountData(group) ||
      this.isPasswordRequirements(group) ||
      this.isSessionTimeout(group);
  }

  shouldShowLabel(field: any, group: any): boolean {
    return field.attributeCode !== 'add_segment' &&
      group.code !== 'features' &&
      field.attributeCode !== 'account_owner_user_id' &&
      field.attributeCode !== 'reset_all_password' && field.attributeCode !== 'can_order' && field.attributeCode !== 'can_manage_patient';
  }

  getLabelClass(field: any): string {
    return field.attributeCode === 'generate_code_for_booking' || field.attributeCode === 'special_login'
      ? 'ml-4'
      : 'field-label flex';
  }

  shouldShowRequiredStar(field: any, group: any): boolean {
    return this.shouldShowLabel(field, group) && field.validation?.required;
  }

  shouldShowHelpTip(field: any, group: any): boolean {
    return this.shouldShowLabel(field, group) &&
      this.cs.getLabelValue(`${this.moduleName}.fields.${field.attributeCode}.helpTips`, this.attributeLabels, 0);
  }

}
